export function isChildOf(parent:HTMLElement, child:HTMLElement):boolean {
	let thisParent = child.parentElement;
	do {
		if (thisParent == parent) {
			return true;
		}
		if (!thisParent) {
			return false;
		}
		thisParent = thisParent.parentElement;
	} while(thisParent != document.body);
	return false;
}

export function hasElOrSomeParentTheClass(el:HTMLElement,
	className:string, stopElement:HTMLElement = document.body):boolean {
	if (el == stopElement) {
		return false;
	}
	if (el.classList.contains(className)) {
		return true;
	}
	if (!el.parentElement) {
		return false;
	}
	return hasElOrSomeParentTheClass(el.parentElement, className, stopElement);
}

export function getParentsWithClassCount(el:HTMLElement, className:string, stopElement:HTMLElement = document.body):number {
	let result = 0;
	if (el == stopElement) {
		return result;
	}
	if (el.classList.contains(className)) {
		result++;
	}
	if (!el.parentElement) {
		return result;
	}
	result += getParentsWithClassCount(el.parentElement, className, stopElement);
	return result;
}